import React from "react";
import { Button } from "../../../node_modules/@material-ui/core";

import TerminalDetails from './TerminalDetails';
import StationDetails from "./StationDetails";

class Step3 extends React.Component {

  render() {
    const { mainClasses, oldTerminalData, handleNext, handleBack } = this.props;

    return (
      <React.Fragment>
          <StationDetails stationPump={oldTerminalData.stationPump} />
          <TerminalDetails title={"Vanhan laitteen tiedot"} terminalData={oldTerminalData} />
          <div className={mainClasses.buttonWrapper}>
            <Button className={mainClasses.stepButton} variant="contained" color="primary" onClick={() => handleNext(1)}>Lue uusi QR-koodi</Button>
          </div>
          <div className={mainClasses.buttonWrapper}>
            <Button className={mainClasses.stepButton} variant="contained" color="secondary" onClick={() => handleNext(2)}>Syötä uusi ID-tunnus</Button>
          </div>
          <div className={mainClasses.buttonWrapper}>
            <Button className={mainClasses.stepButton} variant="outlined" onClick={handleBack}>Takaisin</Button>
          </div>
      </React.Fragment>
    );
  }
}

export default Step3;



// WEBPACK FOOTER //
// ./src/components/Steps/Step3.js